export const oseFields = [
  { label: "Factura Electrónica", value: "03" },
  { label: "Boleta de Venta Electrónica", value: "06" },
  { label: "Nota de Crédito Electrónica - Factura", value: "04" },
  { label: "Nota de Debito Electrónica - Factura", value: "05" },
  { label: "Nota de Crédito Electrónica - Boleta de Venta", value: "11" },
  { label: "Nota de Debito  Electrónica - Boleta de Venta", value: "12" },
  { label: "Comprobante de Percepción", value: "40" },
  { label: "Comprobante de Retención", value: "20" },
  { label: "DOAE - DOCUMENTO DE ATRIBUCION ELECTRONICO", value: "25" },
  { label: "DAE - :DOCUMENTO EMITIDO O INFORMADO POR CONTINGENCIA", value: "28" },
  { label: "SEAE - Documento Autorizado Electrónico por Servicios Aeroportuarios Prestados a Favor de Pasajeros", value: "56" },
  { label: "Envio Resumen - Boleta de Venta", value: "C03" },
  { label: "Envio Resumen - Nota de Crédito", value: "C07" },
  { label: "Envio Resumen - Nota de Débito", value: "C08" },
];
